import JSZip from 'jszip'

type InputBinaryFile = {
    name: string
    content: Blob | ArrayBuffer | Uint8Array
}

type InputTextFile = {
    name: string
    content: string
}

export type CreateDownloadZipParams = {
    archiveName?: string
    files?: File[]
    binaryFiles?: InputBinaryFile[]
    textFiles?: InputTextFile[]
}

export type DownloadZipResult = {
    fileName: string
    blob: Blob
    objectUrl: string
    download: () => void
    revoke: () => void
}

const ZIP_MIME_TYPE = 'application/zip'

const normalizeZipFileName = (fileName: string): string => {
    if (!fileName.trim()) {
        return 'archive.zip'
    }

    if (fileName.toLowerCase().endsWith('.zip')) {
        return fileName
    }

    return `${fileName}.zip`
}

export const createDownloadZip = async ({
    archiveName = 'archive.zip',
    files = [],
    binaryFiles = [],
    textFiles = [],
}: CreateDownloadZipParams): Promise<DownloadZipResult> => {
    const zip = new JSZip()

    files.forEach(file => {
        zip.file(file.name, file)
    })

    binaryFiles.forEach(file => {
        zip.file(file.name, file.content)
    })

    textFiles.forEach(file => {
        zip.file(file.name, file.content)
    })

    const blob = await zip.generateAsync({ type: 'blob', mimeType: ZIP_MIME_TYPE })
    const fileName = normalizeZipFileName(archiveName)
    const objectUrl = URL.createObjectURL(blob)

    const download = () => {
        const link = document.createElement('a')
        link.href = objectUrl
        link.download = fileName
        link.style.display = 'none'
        document.body.appendChild(link)
        link.click()
        document.body.removeChild(link)
    }

    const revoke = () => {
        URL.revokeObjectURL(objectUrl)
    }

    return {
        fileName,
        blob,
        objectUrl,
        download,
        revoke,
    }
}
